import shortId from 'shortid';
import { Loggeable } from '../common/loggeable.cls';
export class Process extends Loggeable {
    constructor(iProvider) {
        super();
        /**
         * @Override
         * settings for this process
         */
        this.settings = {};
        this.iProvider = iProvider;
        this.settings.pid = this.generateProcessId();
    }
    /**
     * generate a unique process id fpr classes
     * implementing the IProcess interface
     * @see IProcess
     */
    generateProcessId() {
        return shortId.generate();
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/lib/process/process.cls.ts
// module id = null
// module chunks = 